import AxiosInstance from '../config/AxiosInstance';

export interface SupplierInventoryResponse {
    clientId: string;
    productId: string;
    cost: number;
    unitCost: number;
    UOMId: string;
    statusId: number;
    conversionFactor: number;
}

export interface SupplierInventoryPayload {
    clientId: string;
    productId: string;
    cost: number;
    unitCost: number;
    UOMId: string;
    statusId: number;
}

const getAllSupplierInventory = async (page: number, limit: number, searchValue: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/supplier-inventory/find-all-supplier`, {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListSupplierInventory = async (val: any) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/supplier-returns`, {
            params: {
                page: val.page,
                limit: val.limit,
                searchReturnNumber: val.searchReturnNumber,
                searchSupplier: val.searchSupplier,
                searchLocation: val.searchLocation,
                searchDeliveryNumber: val.searchDeliveryNumber,
                searchReturnDate: val.searchReturnDate,
                searchAmount: val.searchAmount,
                searchUpdateDate: val.searchUpdateDate,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailSupplierReturn = async (id: any) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/supplier-returns/` + id);
        return { data };
    } catch (error) {
        throw error;
    }
}


const getDetailSupplierInventory = async (clientId: string, page: number, limit: number, searchSku: string, searchName: string, searchUOM: string, searchCost: string, searchUnitCost: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/supplier-inventory/find/${clientId}`, {
            params: {
                page: page,
                limit: limit,
                searchSku: searchSku,
                searchName: searchName,
                searchUOM: searchUOM,
                searchCost: searchCost,
                searchUnitCost: searchUnitCost,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const createProductSupplierInventory = async (payload: SupplierInventoryPayload) => {
    try {
        const { data } = await AxiosInstance.post(`/api/inventory/supplier-inventory`, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateProductSupplierInventory = async (clientId: string, id: string, payload: SupplierInventoryPayload) => {
    try {
        const { data } = await AxiosInstance.put(`/api/inventory/supplier-inventory/update/${clientId}/${id}`, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteProductSupplierInventory = async (clientId: string, id: string,) => {
    try {
        const { data } = await AxiosInstance.delete(`/api/inventory/supplier-inventory/delete/${clientId}/${id}`);
        return { data };
    } catch (error) {
        throw error;
    }
}


export interface CataloguePayload {
    /** Rows added (no id) or changed; the API works the base unit price out from `cost`. */
    lines: { id?: string; productId: string; productUOMId: string; cost: number; statusId: number }[];
    removedIds: string[];
}

// A supplier's whole catalogue, with each product's units.
const getSupplierCatalogue = async (clientId: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/supplier-inventory/${clientId}/catalogue`);
        return { data };
    } catch (error) {
        throw error;
    }
}

// Add products: the company's products, with the units the supplier already prices.
const getSupplierCatalogueProducts = async (clientId: string, page: number, limit: number, searchValue: string, productGroupId?: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/supplier-inventory/${clientId}/catalogue/products`, {
            params: { page, limit, searchValue, ...(productGroupId ? { productGroupId } : {}) },
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

// The catalogue page in one save: rows added, changed and removed.
const saveSupplierCatalogue = async (clientId: string, payload: CataloguePayload) => {
    try {
        const { data } = await AxiosInstance.put(`/api/inventory/supplier-inventory/${clientId}/catalogue`, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    getSupplierCatalogue,
    getSupplierCatalogueProducts,
    saveSupplierCatalogue,
    getDetailSupplierInventory,
    createProductSupplierInventory,
    updateProductSupplierInventory,
    deleteProductSupplierInventory,
    getAllSupplierInventory,
    getListSupplierInventory,
    getDetailSupplierReturn
}